// extracted by mini-css-extract-plugin
export default {"selectChannel":"selectChannel___YVw3a","shortcuts":"shortcuts___NGjg_","dark":"dark","submitBtn":"submitBtn___u0IS6","amount":"amount___yHISy"};